import React, { Fragment } from 'react';
import AbstractComponent from '../../AbstractComponent';
import Panel from '../../layout/panel/Panel';
import Input from '../../layout/input/Input';
import InputPassword from '../../layout/input/InputPassword';
import InputCheckBox from '../../layout/input/InputCheckBox';
import InputSelect from '../../layout/input/InputSelect';
import InputShow from '../../layout/input/InputShow';
import ButtonCol from '../../layout/button/ButtonCol';
import ModalQuestionEmail from '../../layout/modal/ModalQuestionEmail';
import ModalWarning from '../../layout/modal/ModalWarning';
import ModalAlerta from '../../layout/modal/ModalAlerta';
import MyModal from '../../layout/modal/MyModal';
import ModalChangeSenha from './ModalChangeSenha';

import AutenticarService from '../../../service/AutenticarService';
import ClienteContaEmailService from '../../../service/ClienteContaEmailService';
import EmailService from '../../../service/EmailService';
import ModalAguarde from '../../layout/modal/ModalAguarde';

import ConexaoSeguraEnum from '../../../helper/enumerador/ConexaoSeguraEnum';

import { getAppUrlImg } from '../../../helper/Url';

class Email extends AbstractComponent {
    constructor(props) {
        super(props);

        this.state = {
            showModalEmail: false,

            showModalChangeSenha: false,

            warning: '',            

            alerta: {
                message: '',
                code: 0
            },

            aguarde: false,

            img: getAppUrlImg() + 'send-email.gif',            

            width: "250",            

            showSenha: '',

            preloadSenha: false
        }
        
        this.conexaoSeguraType = ConexaoSeguraEnum.list();                           
    }

    onChangeTipoSeguranca(e) {        
        this.props.onChange(e);

        if(this.props.form.tipo_seguranca === '')
            return ;                        
    }  

    onClick() {
        var salvar = this.props.salvar;

        if(!salvar.disabled) {
            this.setState({warning: 'Por favor, clique no botão Salvar antes de executar essa operação.'});

            return ;
        }

        this.setState({ showModalEmail: true })
    }

    onTimeOut() {
        this.setState({
            aguarde: false,
            img: getAppUrlImg() + 'send-email.gif',
            width: "250"
        });
    }

    onTestar(email) {     
        this.setState({ showModalEmail: false, aguarde: true })
    
        EmailService.gravar(
            this.props.form.id,
            email
        ).then(() => {             
             this.setState({                                  
                 img: getAppUrlImg() + 'send-email-ok.png',
                 width: '173'
             });
             
             setTimeout(() => this.onTimeOut(), 2 * 1000);
        }).catch((erro) => {
             this.setState({
                alerta: this.trataErro(erro),     
                aguarde: false,
                img: getAppUrlImg() + 'send-email.gif',
                width: "250"    
             });
        });
    }    

    onButtonSenhaClick() {
        this.setState({preloadSenha: true});

        ClienteContaEmailService.getSenha(
            AutenticarService.getIdEmpresa()
        ).then(resposta => {
            this.setState({
                preloadSenha: false,
                showSenha: resposta.data.senha                
            });
        }).catch(erro => {
            this.props.onErro(this.trataErro(erro));
            this.setState({preloadSenha: false});
        });
    }

    render() {
        return(
            <Fragment>                
                <ModalAlerta
                    show={this.state.alerta.code !== 0}
                    texto={this.state.alerta.message}

                    fechar={() => this.setState({alerta: this.finalizaErro(this.state.alerta)})}
                />

                <ModalWarning
                    show={this.state.warning !== ''}
                    texto={this.state.warning}

                    fechar={() => this.setState({warning: ''})}
                />

                <ModalAguarde
                    show={this.state.aguarde}                                    
                    header="Aguarde enviando e-mail"
                    src={this.state.img}
                    alt="Enviando e-mail"
                    width={this.state.width}
                />

                <ModalQuestionEmail
                    show={this.state.showModalEmail}

                    fechar={() => this.setState({ showModalEmail: false })}
                    acao={ (email) => this.onTestar(email) }
                />

                <ModalChangeSenha
                    show={this.state.showModalChangeSenha}
                    header="Alteração da senha do email"

                    service={ClienteContaEmailService.atualizarSenha}
                    id={this.props.form.id}
                    
                    onSucesso={() => this.setState({ showModalChangeSenha: false })}
                    fechar={() => this.setState({ showModalChangeSenha: false })}
                />

                <MyModal
                    show={this.state.showSenha !== ''}
                    header="Senha do email"
                    texto={this.state.showSenha}
                    buttonTxt="Ok"
                    
                    fechar={() => this.setState({showSenha: '', showSenhaHeader: ''})}
                />

                <div className="col-md-6
                                col-sm-6
                                col-lg-6
                                col-xs-12">                    
                    <Panel
                        md={12}
                        xs={12}
                        sm={12}
                        lg={12}
                        title="Conexão com servidor SMTP"
                    >                        
                        <Input
                            md={6}
                            xs={12}
                            sm={6}
                            lg={6}
                            id="servidor"
                            nome="servidor"
                            tooltip={"Servidor que enviara o email"}
                            value={this.props.form.servidor}                            
                            defaultFoco={true}
                            erro={this.props.erroForm.servidor}
                            onChange={(e) => this.props.onChange(e)}

                        >
                            Servidor
                        </Input>

                        <Input
                            md={6}
                            xs={12}
                            sm={6}
                            lg={6}
                            id="porta"
                            nome="porta"
                            tooltip={"Porta usada para o envio"}
                            value={this.props.form.porta}                            
                            erro={this.props.erroForm.porta}
                            onChange={(e) => this.props.onChange(e)}

                        >
                            Porta
                        </Input>

                        <InputShow
                            md={6}
                            xs={12}
                            sm={6}
                            lg={6}
                            id="usuario_email"
                            nome="usuario_email"
                            tooltip={"Nome que aparecerá no corpo do email"}
                            showButton={this.props.usuario.admin && this.props.form.usuario_email}
                            preload={this.state.preloadSenha}
                            value={this.props.form.usuario_email}                            
                            erro={this.props.erroForm.usuario_email}
                            onChange={(e) => this.props.onChange(e)}
                            onButtonClick={() => this.onButtonSenhaClick()}
                        >
                            Usuário
                        </InputShow>

                        {
                            !this.props.form.email &&
                            <InputPassword
                                md={6}
                                xs={12}
                                sm={6}
                                lg={6}
                                id="senha"
                                nome="senha"
                                value={this.props.form.senha}
                                erro={this.props.erroForm.senha}
                                onChange={(e) => this.props.onChange(e)}
                            >
                                Senha
                            </InputPassword>
                        }   

                        {
                            this.props.form.email &&
                            <ButtonCol
                                md={6}
                                xs={12}
                                sm={6}
                                lg={6}
                                id="btnSenhaEmail"
                                nome="btnSenhaEmail"                                
                                onClick={() => this.setState({showModalChangeSenha: true})}
                            >
                                ALTERAR SENHA
                            </ButtonCol>
                        }   

                        <InputCheckBox
                            md={6} 
                            xs={12}
                            sm={6} 
                            lg={6}
                            id="auth"
                            nome="auth"
                            value={this.props.form.auth}                             
                            erro={this.props.erroForm.auth}
                            checked={parseInt(this.props.form.auth,10) === 1}                            
                            onChange={(e) => this.props.onChange(e)}                   
                        >                    
                            Utilizar conexão segura SSL/TLS
                        </InputCheckBox>

                        <InputSelect
                            md={6} 
                            xs={12} 
                            sm={6} 
                            lg={6}
                            id="smtp_seguranca"
                            nome="smtp_seguranca"
                            value={this.props.form.smtp_seguranca}
                            erro={this.props.erroForm.smtp_seguranca}
                            disabled={parseInt(this.props.form.auth, 10) === 0}
                            options={this.conexaoSeguraType}
                            onChange={e => this.onChangeTipoSeguranca(e)}
                        >
                            Tipo de conexão segura
                        </InputSelect>   
                    </Panel>
                </div>

                <div className="col-md-6
                                col-sm-6
                                col-lg-6
                                col-xs-12">  
                    <Panel
                        md={12}
                        xs={12}
                        sm={12}
                        lg={12}
                        title="Informações de envio do email"
                    >   
                        <Input
                            md={12}
                            xs={12}
                            sm={12}
                            lg={12}
                            id="nome_exibicao"
                            nome="nome_exibicao"
                            value={this.props.form.nome_exibicao}                        
                            tooltip={"Nome que aparecerá no corpo do email"}
                            erro={this.props.erroForm.nome_exibicao}
                            onChange={(e) => this.props.onChange(e)}

                        >
                            Nome de Exibicao
                        </Input>

                        <Input
                            md={12}
                            xs={12}
                            sm={12}
                            lg={12}
                            id="email"
                            nome="email"
                            value={this.props.form.email}                            
                            erro={this.props.erroForm.email}
                            onChange={(e) => this.props.onChange(e)}

                        >
                            Email
                        </Input>
                    </Panel>                                       
                </div>       

                <div 
                    className="col-md-12
                               col-sm-12
                               col-lg-12
                               col-xs-12"
                    style={{
                        alignContent: 'center',
                        display: 'grid',
                        paddingLeft: '30px',
                        paddingRight: '30px'                                                    
                    }}
                > 
                    <button                        
                        className="btn btn-info"
                        type="button"
                        onClick={() => this.onClick() }
                    >
                        TESTAR ENVIO
                    </button>
                </div>          
            </Fragment>
        )
    }
}

export default Email;